import { render } from "./Header.vue?vue&type=template&id=264ef748&scoped=true&bindings={\"name\":\"props\",\"fromLocation\":\"props\",\"toLocation\":\"props\",\"imageURL\":\"props\",\"aareGuruAPIData\":\"options\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=264ef748&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-264ef748"

export default script